import { render } from "./HeaderImageBoxGenerel.vue?vue&type=template&id=7939f870"
import script from "./HeaderImageBoxGenerel.vue?vue&type=script&lang=ts"
export * from "./HeaderImageBoxGenerel.vue?vue&type=script&lang=ts"

import "./HeaderImageBoxGenerel.vue?vue&type=style&index=0&id=7939f870&lang=scss"
script.render = render

export default script